import React, { useState } from 'react';
import { DataGrid, GridToolbarContainer, GridToolbarColumnsButton,GridToolbarDensitySelector,GridToolbarExport,GridToolbarFilterButton,GridRow, GridCell } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import addIdToData from '../../utilities/addIdToData';
import voucherDateAndTimeFormatter from '../../utilities/voucherDateAndTimeFormatter';

export default function VoucherDataTableMonthly({ TableData, TableColumns, tableName, height = 450 }) {
    const formatRegData = voucherDateAndTimeFormatter(TableData, ['entryDate','voucherPurchaseDate', 'requestedTimePreiodDate', 'appliedDate', 'dateOfBirth', 'mentorJoiningDate', 'retirementYear']);
     
    const DataWithId = addIdToData(formatRegData);
    const [expandedRowId, setExpandedRowId] = useState(null);

    const handleRowClick = (id) => {
        setExpandedRowId(expandedRowId === id ? null : id);
    };

    function CustomToolbar() {
        return (
            <GridToolbarContainer>
                 <GridToolbarColumnsButton
                    slotProps={{
                        tooltip: { title: 'Export data' },
                        button: { variant: 'outlined' },
                    }}
                />
                 <GridToolbarFilterButton
                    slotProps={{
                        tooltip: { title: 'Export data' },
                        button: { variant: 'outlined' },
                    }}
                />
                 <GridToolbarDensitySelector
                    slotProps={{
                        tooltip: { title: 'Export data' },
                        button: { variant: 'outlined' },
                    }}
                />
                {/* <GridToolbarColumnsButton />
                <GridToolbarFilterButton />
                <GridToolbarDensitySelector
                    slotProps={{ tooltip: { title: 'Change density' } }}
                /> */}

                
                <GridToolbarExport
                    slotProps={{
                        tooltip: { title: 'Export data' },
                        button: { variant: 'outlined' },
                    }}
                />
            </GridToolbarContainer>
        );
    }
      

    const columns = TableColumns.map((col) => {
        if (col.field === 'name') {
            return {
                ...col,
                renderCell: (params) => (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Avatar src={`https://api.adorable.io/avatars/50/${params.value}.png`} style={{ marginRight: 8 }} />
                        {params.value}
                    </div>
                ),
            };
        }
        return col;
    });

    const rows = DataWithId.map((row) => ({
        ...row,
        id: row.id || row.advocateBarId, // Ensure each row has a unique id
    }));

    const renderExpandableContent = (row) => (
        <Collapse in={expandedRowId === row.id} timeout="auto" unmountOnExit>
            <Box margin={1}>
                <div style={{ padding: 16, backgroundColor: '#f5f5f5' }}>
                    <h4>Details for {row.name}</h4>
                    <p>Email: {row.email}</p>
                    <p>Age: {row.age}</p>
                    <p>Date of Birth: {row.dateOfBirth}</p>
                    <p>Status: {row.status}</p>
                    <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
                        <Button variant="contained" color="success" onClick={() => handleAccept(row.id)}>
                            Accept
                        </Button>
                        <Button variant="contained" color="error" onClick={() => handleReject(row.id)}>
                            Reject
                        </Button>
                    </Box>
                    <p>Additional details can be added here...</p>
                </div>
            </Box>
        </Collapse>
    );

    const handleAccept = (id) => {
        console.log('Accepted:', id);
        // Handle accept action here
    };

    const handleReject = (id) => {
        console.log('Rejected:', id);
        // Handle reject action here
    };

    return (
        <div className="row justify-content-center mb-4">
            <div className="col-xxl-9">
                <div className='mt-5' style={{ height: height }}>
                    <h2 className="mb-3 text-center">{tableName}</h2>
                    <DataGrid
                        rows={rows}
                        columns={[
                            // {
                            //     field: 'expand',
                            //     headerName: '',
                            //     width: 50,
                            //     filterable:false,
                            //     sortable: false,
                            //     hideable:false,
                                                            
                            //     renderCell: (params) => (
                            //         <IconButton onClick={() => handleRowClick(params.row.id)}>
                            //             {expandedRowId === params.row.id ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                            //         </IconButton>
                            //     ),
                            // },
                            ...columns,
                        ]}
                        slots={{
                            toolbar: CustomToolbar,
                          }}

                        components={{ Toolbar: CustomToolbar }}
                        disableRowSelectionOnClick
                        hideFooterPagination
                        getRowId={(row) => row.id}
                    />
                    {/* {rows.map((row) => (
                        <div key={row.id}>
                            {expandedRowId === row.id && (
                                <div style={{ gridColumn: '1 / -1' }}>
                                    {renderExpandableContent(row)}
                                </div>
                            )}
                        </div>
                    ))} */}
                </div>
            </div>
        </div>
    );
}
